import { render } from "./ActionLink.vue?vue&type=template&id=4a7fbc72&scoped=true"
import script from "./ActionLink.vue?vue&type=script&lang=js"
export * from "./ActionLink.vue?vue&type=script&lang=js"

import "./ActionLink.vue?vue&type=style&index=0&id=4a7fbc72&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4a7fbc72"

export default script